import angular from "angular"
import angularUIB from "angular-ui-bootstrap";
import notify from "@cgross/angular-notify";

let mod = angular
    .module('orderHistory', [angularUIB, notify])
    .component('orderHistory', {
        template: require('./order-history.html'),
        controller: ['$uibModal', 'notify', controller],
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        }
    });

function controller($uibModal, notify) {

    let $ctrl = this;

    $ctrl.$onInit = function () {
        $ctrl.order = $ctrl.resolve.order;
        $ctrl.changeTypes = {
            'book': 'Забронирован',
            'send-to-confirm': 'Отпр. на оформление',
            'confirm-success': 'Успешно оформилась',
            'confirm-fail': 'Ошибка при оформлении',
            'cancel': 'Отменен',
            'auto-cancel': 'Авт. отменен',
            'send-to-refund': 'Отпр. на возврат',
            'refund-success': 'Успешно возвращен',
            'refund-reject': 'Возврат отвергнут',
            'refund-error': 'Ошибка при возвратe',
        };
    };

    $ctrl.showErrorMessage = function (change) {
        notify({
            message: change.fail_message,
            classes: 'alert-danger'
        });
    };
}

export default mod.name;


// WEBPACK FOOTER //
// ./resources/assets/modules/orders/components/order-history/order-history.js